<template>
  <div>
    <div class="row mb-2">
      <div class="col-6">
        <input
          class="form-control"
          type="text"
          v-model="nameProfile"
          :placeholder="$t('menu.settings.users.placeholderProfileName')"
        />
      </div>
      <div class="col-6">
        <div class="pull-right"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-4" v-for="(item, i) in permissions" :key="i">
        <item-profile
          :items="permissions[i]"
          :fields="[
            {
              key: 'name',
              label: `${$t('menu.settings.users.labels.menu')} ${i}`,
            },
            {
              key: 'value',
              label: $t('menu.settings.users.labels.enable'),
            },
          ]"
          :p-key="i"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import itemProfile from './item-profile';
import EventBus from '../../../../eventBus';

export default {
  name: 'modalProfile',
  components: {
    itemProfile,
  },
  data: () => ({
    userAuth: null,
  }),
  props: {
    profile: {
      type: Object,
    },
  },
  computed: {
    ...mapState('profiles', ['permissions', 'profileId']),
    ...mapFields('profiles', ['nameProfile']),
  },
  methods: {
    ...mapActions('profiles', [
      'createProfile',
      'getProfiles',
      'setStateProfile',
      'editProfile',
    ]),
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    if (this.profile) {
      this.profile.lang = this.$i18n.locale;
      await this.setStateProfile(this.profile);
    }
    EventBus.$on('save-profile', async () => {
      if (this.profile) {
        await this.editProfile({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          profileId: this.profileId,
          nameProfile: this.nameProfile
        });
      } else {
        await this.createProfile({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
        });
      }

      await this.getProfiles({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
      });
    });
  },
  beforeDestroy() {
    EventBus.$off('save-profile');
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/organisms/settings/profiles/modal-profile.vue